export function getTerminalShortcutSequence(
  event: KeyboardEvent,
): string | null {
  if (event.metaKey) {
    return null;
  }
  if (event.ctrlKey && !event.altKey) {
    if (event.key === 'a' || event.key === 'A') {
      return '\x01';
    }
    if (event.key === 'e' || event.key === 'E') {
      return '\x05';
    }
    if (event.key === 'w' || event.key === 'W') {
      return '\x17';
    }
    if (event.key === 'u' || event.key === 'U') {
      return '\x15';
    }
  }
  if (event.altKey && !event.ctrlKey) {
    if (event.key === 'ArrowLeft') {
      return '\x1bb';
    }
    if (event.key === 'ArrowRight') {
      return '\x1bf';
    }
    if (event.key === 'Backspace') {
      return '\x1b\x7f';
    }
  }
  return null;
}
